import { useState, useEffect } from 'react'
import { supabase } from './supabase'

// Global "is the site live?" switch, controlled from Admin → Settings.
//   admin_settings key 'launch' → { live: boolean }
// When live === false the whole site is sealed behind the waitlist (see
// LaunchGate in App.jsx); admins still get through so they can keep working.
// Missing/unknown defaults to LIVE, so nothing breaks if the row was never set.

let _cache = null   // in-flight / resolved promise
let _value = null   // last resolved { live }

export function fetchLaunch() {
  if (!_cache) {
    _cache = supabase
      .from('admin_settings').select('value').eq('key', 'launch').maybeSingle()
      .then(({ data }) => { _value = { live: data?.value?.live !== false }; return _value })
      .catch(() => { _value = { live: true }; return _value })
  }
  return _cache
}

// Synchronous peek at the last resolved value (null until first fetch resolves).
export function getLaunchSync() { return _value }

export function useSiteLive() {
  const [live, setLive] = useState(_value ? _value.live : null)
  useEffect(() => { fetchLaunch().then(s => setLive(s.live)) }, [])
  return live   // null = still loading, otherwise true/false
}
